import { AutogenLayoutTimecardTotalsQuickInfo } from "./autogen/AutogenLayoutTimecardTotalsQuickInfo";
import { getPayrollControlBoolean } from "@mcleod/general";
import { DataSourceExecutionEvent, PrintableEvent } from "@mcleod/components";
import { Currency, CurrencySettings, DisplayType, DisplayValue, HorizontalAlignment, StringUtil } from "@mcleod/core";

export class TimecardTotalsQuickInfo extends AutogenLayoutTimecardTotalsQuickInfo {
    onLoad(): void | Promise<void> {
        this.textboxAddlTaxOverrideHours.visible = getPayrollControlBoolean("addl_tax_override_hours", false);
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (StringUtil.isEmptyString(this.textboxHolidayTotal.text)){
                this.textboxHolidayTotal.text = DisplayValue.getDisplayValue(new Currency({ amount: 0, currency_code: this.activeRow?.get("payee.currency", CurrencySettings.getFunctionalCurrency())}), DisplayType.CURRENCY);
            }
            if (StringUtil.isEmptyString(this.textboxOvertimeTotal.text)){
                this.textboxOvertimeTotal.text = DisplayValue.getDisplayValue(new Currency({ amount: 0, currency_code: this.activeRow?.get("payee.currency", CurrencySettings.getFunctionalCurrency())}), DisplayType.CURRENCY);
            }
            if (StringUtil.isEmptyString(this.textboxRegularTotal.text)){
                this.textboxRegularTotal.text = DisplayValue.getDisplayValue(new Currency({ amount: 0, currency_code: this.activeRow?.get("payee.currency", CurrencySettings.getFunctionalCurrency())}), DisplayType.CURRENCY);
            }
            if (StringUtil.isEmptyString(this.textboxSickTotal.text)){
                this.textboxSickTotal.text = DisplayValue.getDisplayValue(new Currency({ amount: 0, currency_code: this.activeRow?.get("payee.currency", CurrencySettings.getFunctionalCurrency())}), DisplayType.CURRENCY);
            }
            if (StringUtil.isEmptyString(this.textboxVacationTotal.text)){
                this.textboxVacationTotal.text = DisplayValue.getDisplayValue(new Currency({ amount: 0, currency_code: this.activeRow?.get("payee.currency", CurrencySettings.getFunctionalCurrency())}), DisplayType.CURRENCY);
            }
        });
    }

    textboxVacationOnPrintable(event: PrintableEvent): void {
        event.printableLabel.align = HorizontalAlignment.LEFT;
    }

    textboxSickOnPrintable(event: PrintableEvent): void {
        event.printableLabel.align = HorizontalAlignment.LEFT;
    }
}
